require('./images/register-background.jpg');
require('./images/retailer.jpg');
require('./images/supplier.jpg');
require('./images/supplier-animation.gif');
require('./images/success-confetti.mp4');
require('./images/map.png');
require('./images/btn-google-signin.svg');
require('./images/google.svg');
